import {
    MagnifyingGlassIcon,
    BellIcon,
    BookmarkIcon,
    ArrowTrendingUpIcon,
    ChatBubbleOvalLeftIcon,
    BuildingOfficeIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MessageMenu from "./MessageMenu";
import { matchPath, useLocation } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { UserIcon } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchQuery } from "../../../slices/searchSlice";
import SearchInput from "../../sharedComponents/SearchInput";
import avatar from "../../../assets/images/Avatar.avif"
import NotificationMenu from "./NotificationMenu";
import { getMyNotifications, markAllAsRead } from "../../../slices/9-notification/thunk";

const Navbar = ({ onToggleRight }) => {
    const { t } = useTranslation();
    const [isMessageOpen, setIsMessageOpen] = useState(false);
    const toggleMessageDrawer = () => {
        setIsMessageOpen(!isMessageOpen)
    };
    const { profile } = useSelector((state) => state.myProfile);
    const { notifications } = useSelector((state) => state.notification);

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const dispatch = useDispatch();
    const searchQuery = useSelector((state) => state.search.query);
    // console.log(searchQuery)
    const bellRef = useRef(null);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    const unreadCount =
        notifications?.filter((n) => !n.isRead).length || 0;
    useEffect(() => {
        dispatch(getMyNotifications({ page: 1, limit: 20 }));
    }, [dispatch]);


    const handleNotificationClick = (e) => {
        e.stopPropagation();
        if (isNotificationOpen) {
            setIsNotificationOpen(false);
        } else {
            setIsNotificationOpen(true);
        }
    };


    const navbarConfig = () => {
        if (pathname === "/") {
            return {
                type: "search",
                placeholder: t("navbar.search_posts"),
            };
        }

        if (pathname === "/trending") {
            return {
                type: "title",
                title: t("rightSidebar.trending_now"),
                icon: ArrowTrendingUpIcon,
            };
        }
        if (pathname === "/saved") {
            return {
                type: "title",
                title: t("saved"),
                icon: BookmarkIcon,
            };
        }

        if (pathname === "/profile") {
            return {
                type: "title",
                title: `${profile?.fullName}`,
                // username: `${profile?.firstName}`,
                icon: UserIcon,
                // showBack: true,
            };
        }
        if (pathname === "/privacy") {
            return {
                type: "title",
                title: t("privacyPolicy.title"),
                showBack: true,
            };
        }
        if (pathname === "/terms-condition") {
            return {
                type: "title",
                title: t("terms.title"),
                showBack: true,
            };
        }
        if (pathname === "/about") {
            return {
                type: "title",
                title: t("aboutUs.title"),
                showBack: true,
            };
        }
        if (pathname === "/contact") {
            return {
                type: "title",
                title: t("underlineform.title"),
                showBack: true,
            };
        }
        if (pathname === "/mycompany") {
            return {
                type: "title",
                title: t("company.tab"),
                icon: BuildingOfficeIcon,
            };
        }
        if (matchPath("/profile-company/:slug", pathname)) {
            return {
                type: "title",
                title: t("settings.Posts"),
                // username: `${profile?.firstName}`,
                showBack: true,
                // showBack: true,
            };
        }
        if (pathname === "/profile/edit") {
            return {
                type: "title",
                title: t("profile.edit"),
                showBack: true,
            };
        }
        if (matchPath("/post/:id", pathname)) {
            return {
                type: "title",
                title: t("settings.Posts"),
                showBack: true,
            };
        }
        if (matchPath("/profile/:id", pathname)) {
            return {
                type: "title",
                title: `${profile?.fullName}`,
                showBack: true,
            };
        }
        if (pathname === "/settings/posts") {
            return {
                type: "dashboard",
                title: t("settings.title"),
                placeholder: t("search.posts"),
                searchType: "ADMIN_POSTS",
                showBack: true,
            };
        }

        if (pathname === "/settings/companies") {
            return {
                type: "dashboard",
                title: t("settings.title"),
                placeholder: t("search.companies"),
                searchType: "ADMIN_COMANY",
                showBack: true,
            };
        }
        if (pathname === "/settings/reviews") {
            return {
                type: "dashboard",
                title: t("settings.title"),
                placeholder: t("search.reviews"),
                searchType: "ADMIN_COMANY",
                showBack: true,
            };
        }
        if (pathname === "/settings/users") {
            return {
                type: "dashboard",
                title: t("settings.title"),
                placeholder: t("search.users"),
                searchType: "ADMIN_USERS",
                showBack: true,
            };
        }
        if (pathname === "/settings/contact") {
            return {
                type: "dashboard",
                title: t("settings.title"),
                placeholder: t("search.contacts"),
                searchType: "ADMIN_CONTACT",
                showBack: true,
            };
        }
        return {
            type: "title",
            title: t("navbar.default"),
        };
    };

    const config = navbarConfig();

    // console.log(unreadCount)
    return (
        <div
            className="sticky top-0 z-40 transition-colors border-b border-border-light backdrop-blur bg-bg-light-secondary dark:bg-bg-dark-secondary dark:border-border-dark "
        >
            <div className={`flex items-center justify-between h-16 px-4 ${config.type !== "dashboard" ? "max-container" : ""} `}>
                <div className="flex items-center gap-2 lg:hidden">
                    {(config.type === "title" || config.type === "profile" || config.type === "dashboard") && config.showBack && (
                        <div>
                            <button
                                onClick={() => navigate(-1)}
                                className="p-1 text-black duration-300 rounded-full hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary dark:text-white dark:hover:text-primary hover:text-primary-light rtl:rotate-180"
                            >
                                <ArrowLeftIcon className="w-5 h-5" />
                            </button>
                        </div>
                    )}
                    <button
                        onClick={onToggleRight}
                        className="rounded-full lg:hidden hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                    >
                        <img className="w-8 h-8 rounded-full" src={profile?.avatar || avatar} alt="avater" />
                    </button>
                </div>
                {config.type === "search" && (
                    <SearchInput
                        value={searchQuery}
                        placeholder={t("search.posts")}
                        onChange={(value) => dispatch(setSearchQuery(value))}
                        width="lg:w-[300px] w-[60%]"
                    />
                )}
                {config.type === "title" && (
                    <div className="items-center hidden gap-3 lg:flex">
                        {config.showBack && (
                            <button
                                onClick={() => navigate(-1)}
                                className="p-1 text-black duration-300 rounded-full hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary dark:text-white dark:hover:text-primary hover:text-primary-light rtl:rotate-180"
                            >
                                <ArrowLeftIcon className="w-5 h-5" />
                            </button>
                        )}

                        {config.icon && (
                            <config.icon className="w-6 h-6 dark:text-primary text-primary-light" />
                        )}

                        <h1 className="text-lg font-semibold text-black dark:text-white ">
                            {config.title}
                        </h1>
                    </div>
                )}
                {config.type === "profile" && (
                    <div className="flex items-center gap-3">
                        {config.showBack && (
                            <button
                                onClick={() => navigate(-1)}
                                className="p-1 text-black duration-300 rounded-full hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary dark:text-white dark:hover:text-primary hover:text-primary-light rtl:rotate-180"
                            >
                                <ArrowLeftIcon className="w-5 h-5" />
                            </button>
                        )}

                        <div>
                            <h1 className="text-lg font-semibold text-black dark:text-white">
                                {config?.title}
                            </h1>
                            <p className="text-sm text-text-muted-light">
                                @{config?.username.toLowerCase().replace(" ", "")}
                            </p>
                        </div>
                    </div>
                )}
                {config.type === "dashboard" && (
                    <div className="items-center hidden gap-3 lg:flex">
                        {config.showBack && (
                            <button
                                onClick={() => navigate(-1)}
                                className="p-1 text-black duration-300 rounded-full hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary dark:text-white dark:hover:text-primary hover:text-primary-light rtl:rotate-180"
                            >
                                <ArrowLeftIcon className="w-5 h-5" />
                            </button>
                        )}

                        {config.icon && (
                            <config.icon className="w-6 h-6 dark:text-primary text-primary-light" />
                        )}

                        <h1 className="text-lg font-semibold text-black dark:text-white">
                            {config.title}
                        </h1>

                        <SearchInput
                            value={searchQuery}
                            placeholder={t(`${config.placeholder}`)}
                            onChange={(value) => dispatch(setSearchQuery(value))}
                            width="lg:w-[300px] w-[60%]"
                        />

                    </div>
                )}

                {/* Actions */}
                <div className="flex items-center gap-2 lg:gap-4">
                    {/* Notifications */}
                    <div className="relative" ref={bellRef}>
                        <button
                            onClick={handleNotificationClick}
                            className="relative mt-1 text-gray-600 transition-colors dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                        >
                            <BellIcon className="w-6 h-6 " />
                            {unreadCount > 0 && (
                                <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[16px] h-4 px-1 text-xs  rounded-full dark:bg-primary bg-primary-light dark:text-black text-white">
                                    {unreadCount > 99 ? "99+" : unreadCount}
                                </span>
                            )}
                        </button>

                        {isNotificationOpen && (
                            <NotificationMenu
                                onClose={() => setIsNotificationOpen(false)}
                                triggerRef={bellRef}
                                notifications={notifications}
                                unreadCount={unreadCount}
                            />
                        )}
                    </div>

                    {/* Comments */}
                    <button
                        className="relative text-gray-600 transition-colors dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                        onClick={() => toggleMessageDrawer()}
                        s>
                        <ChatBubbleOvalLeftIcon className="w-5 h-5" />
                    </button>

                </div>
            </div>
            {/* Bell Drawer */}
            {isMessageOpen && (
                <MessageMenu
                    isBellDrawerOpen={isMessageOpen}
                    toggleBellDrawer={toggleMessageDrawer}
                />
            )}
        </div>
    );
};

export default Navbar;
